import u from 'jquery';
import anime from 'animejs';
import PerfectScrollbar from "perfect-scrollbar";
import { Portfolio } from "./portfolio";

export class Menu {
  static init() {
    u('body').on('click', '.hamburger', (e) => {
      e.preventDefault();
      if (u(e.currentTarget).hasClass('show')) {
        Menu.close();
      } else {
        Menu.open();
      }
    });
  }

  static close() {
    u('.hamburger').removeClass('show');
    u('#menu').removeClass('show');
  }

  static open() {
    u('.hamburger').addClass('show');
    u('#menu').addClass('show');
    u('#menu h1').each(function (e) {
      u(this).html(u(this).text().replace(/([^\x00-\x80]|\w)/g, "<span class='letter'>$&</span>"));
    });

    anime({
      targets: '#menu .letter',
      translateX: [40, 0],
      translateZ: 0,
      opacity: [0, 1],
      easing: "easeOutExpo",
      duration: 1200,
      delay: function (el, i) {
        return 500 + 30 * i;
      }
    });

    anime({
      targets: '#menu li',
      translateX: [40, 0],
      translateZ: 0,
      opacity: [0, 1],
      easing: "easeOutExpo",
      duration: 1200,
      delay: function (el, i) {
        return 500 + 30 * i;
      }
    });
  }
}

export class Popup {
  static init() {
    u('.btn-close', '#popup').on('click', e => {
      e.preventDefault();
      Routing.restore();
    });
  }

  static close() {
    u('#popup').removeClass('show');
  }

  static open(data) {
    fetch(data.file).then(response => {
      return response.text();
    }).then(html=>{
      if(html) {
        const $popup = u('#popup');
        $popup.html(html);

        new PerfectScrollbar('#popup .content', {
          suppressScrollX: true
        });

        if(data.portfolio) {
          Portfolio.renderFullFolio(data);
        }

        setTimeout(()=>{
          $popup.addClass('show');
        }, 100);
      }
    });
  }
}

export class Routing {
  static addSubpages(data) {
    data.forEach(i => {
      this.list.set(i.url, i);

      if (i.ref) {
        this.ids.set(i.ref, i.url);
      }
    })
  }

  static init() {
    this.ids = new Map();
    this.list = new Map();
    this.previous = null;
    this.animation = false;

    Routing.addSubpages(require('./subpages.json'));

    window.addEventListener('popstate', Routing.popstate);
    window.addEventListener('readystatechange', Routing.popstate.bind(Routing));

    u('body').on('click', '.btn-goto', (e) => {
      e.preventDefault();
      Routing.go(u(e.currentTarget).data('url'));
    });
  }

  static go(url, title = null, data = null) {
    this.previous = location.pathname;
    history.pushState(data, title, url);
    Routing.change(url)
  }

  static replace(url, title = null, data = null) {
    Routing.previous = location.pathname;
    history.replaceState(data, title, url);
  }

  static replaceById(id) {
    if (!id || !this.ids || this.animation) {
      return;
    }
    const url = this.ids.get(id);
    if (url) {
      Routing.replace(url);
    }
  }

  static restore() {
    Routing.go(this.previous);
  }

  static change(url, fast = false) {
    const regexp = url.match('^\/portfolio\/(.*)');
    const subpage = Routing.list.get(url);

    if (!subpage) {
      return;
    }

    if(regexp) {
      subpage.portfolio = true;
      subpage.file = '/subpage/portfolio.html';
    }

    Menu.close();
    Popup.close();

    if (subpage.file) {
      Popup.open(subpage);
    } else if (subpage.ref && u(subpage.ref).length > 0) {
      this.animation = true;
      u('#app').animate({ 'scrollTop': '+=' + u(subpage.ref).offset().top }, fast ? 10 : 1500, 'easeInOutExpo', () => {
        this.animation = false;
      });
    }
  }

  static popstate(e) {
    Routing.change(document.location.pathname);
  }
}
